import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";
import { Result, Flags } from "core/utils";
import { Raw } from "core/components";
import { trackPageResult } from "./trackPageResult";
import { PageMeta } from "./PageMeta";
import { useStatus } from "common/Auth/Utils/state";
import { globalPageInfo } from "core/tracking/data";
export var prepRouter = function (getData) {
    return function (_a) {
        var appState = _a.appState, slug = _a.slug, setNavConfig = _a.setNavConfig, Loading = _a.Loading, Error = _a.Error;
        var result = getData(appState, slug);
        var authState = useStatus();
        useEffect(function () {
            if (authState.kind !== "Pending") {
                trackPageResult(result);
            }
        }, [slug, result.kind, authState.kind]);
        return Result.fold({
            onLoading: function () {
                return React.createElement(Loading, null);
            },
            onFail: function (error) { return React.createElement(Error, { error: error }); },
            onSuccess: function (payload) {
                globalPageInfo(payload);
                switch (payload.kind) {
                    case "Redirected":
                        return React.createElement(Redirect, { to: payload.redirectUrl });
                    case "Matched": {
                        var page = payload.page, route = payload.route;
                        setNavConfig({
                            isShown: !route.showNav || route.showNav(page),
                            hideFooter: (route.hideFooter && route.hideFooter(page)) || false,
                        });
                        return (React.createElement(React.Fragment, null,
                            React.createElement(PageMeta, { page: page, origin: appState.origin }),
                            React.createElement(route.page, { data: page, fromCache: false }),
                            Flags.showRouterQueryResult && React.createElement(Raw, null, page)));
                    }
                }
            },
        })(result);
    };
};
